import type { AchievementLevel } from './schemas'

/***************** 성취도 등급 색상 *****************/
export const ACHIEVEMENT_LEVEL_COLOR = {
  WHITE: '#fff',
  GRAY: '#E0E0E0',
  SAD: '#FF705C',
  RED: '#FF705C',
  YELLOW: '#FFC34D',
  GREEN: '#7FE166',
  SMILE: '#7FE166',
} as const satisfies Record<AchievementLevel, string>

/***************** 성취도 등급 한글 표기 *****************/
export const ACHIEVEMENT_LEVEL_KO = {
  WHITE: '화이트',
  GRAY: '그레이',
  SAD: '새드',
  RED: '레드',
  YELLOW: '옐로우',
  GREEN: '그린',
  SMILE: '스마일',
} as const satisfies Record<AchievementLevel, string>

/***************** 성취도 등급별 개수 집계 시작값 *****************/
// reduce 의 시드라 `as const` 를 붙이지 않는다. 붙이면 누산 결과가 `{ WHITE: 0, … }` 리터럴로 굳어
// 실제 개수와 비교할 수 없다.
export const ACHIEVEMENT_LEVEL_COUNT_DEFAULTS = {
  WHITE: 0,
  GRAY: 0,
  SAD: 0,
  RED: 0,
  YELLOW: 0,
  GREEN: 0,
  SMILE: 0,
} satisfies Record<AchievementLevel, number>
